
import { useNavigate } from 'react-router-dom';
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { AlertScreen } from '../../components/AlertScreen'
import { envVariables } from '../../../../helpers';
import { TooltipAndIcon } from '../../components/TooltipAndIcon';

const paginado = Number(envVariables.REACT_APP_PAGINADO);





export const TablaProveedores = ({ data, chagePage, page }) => {


    const navigate = useNavigate();
    const totalBodega = 50;


    const handleInfoEditar = async(id) => {
        navigate(`/admin/add/${id}/proveedor`);
    }



    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'30%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'20%'}}>NIT</TableCell>
                                <TableCell sx={{width:'15%'}}>FORMA PAGO</TableCell>
                                <TableCell sx={{width:'10%'}}>CIUDAD</TableCell>
                                <TableCell sx={{width:'10%'}}>TELEFONO</TableCell>
                                <TableCell sx={{width:'15%'}}>OPCIONES</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.map( (pro) => (
                            <TableRow key={ pro.id } >
                                <TableCell >{ pro.nombre }</TableCell>
                                <TableCell>{ pro.nit }</TableCell>
                                <TableCell>{ pro.formaPago }</TableCell>
                                <TableCell>{ pro?.ciudad?.name }</TableCell>
                                <TableCell>{ pro.movil }</TableCell>
                                <TableCell>
                                    <TooltipAndIcon
                                        titulo='Editar Proveedor'
                                        icono='setting'
                                        onClick={ () => handleInfoEditar(pro.id) }
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalBodega / paginado)} disabled={Math.ceil(totalBodega / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay proveedores por el momento..."/>
        }
        </>
    )
}
